import PropTypes from "prop-types"

import "./upsell.scss"

const Upsell = ({ onSkip, onTryProClick, trialConfig }) => {
  const title = trialConfig.holidayCopies ? "Best deal yet" : "Start your trial"
  const body = trialConfig.holidayCopies
    ? "For a limited time, get 22% off Pro. Get full access to our most popular Applets and features that make your favorite things work better together."
    : "Subscribe to get full access to popular Applets and features. Make your favorite things work better together."

  return (
    <>
      <div styleName="container">
        <section styleName="welcome">
          <img
            src={trialConfig.assets.proIllustration}
            alt="Try Pro for Free"
          />
          <h1>{title}</h1>
          <p>{body}</p>
        </section>

        <div className="flexbox">
          <section
            styleName="action-buttons-container"
            className="action-buttons-container"
          >
            <a
              href={trialConfig.urls.proSubscriptionsUrl}
              role="button"
              data-turbolinks="false"
              className="button-primary pay-later"
              onClick={onTryProClick}
            >
              Continue
            </a>

            <a onClick={onSkip} styleName="skip-pro-link">
              Not now
            </a>
          </section>
        </div>
      </div>
    </>
  )
}

Upsell.propTypes = {
  onSkip: PropTypes.func,
  onTryProClick: PropTypes.func,
  trialConfig: PropTypes.shape({
    assets: PropTypes.shape({
      proIllustration: PropTypes.string.isRequired,
    }),
    holidayCopies: PropTypes.bool,
    urls: PropTypes.shape({
      proSubscriptionsUrl: PropTypes.string.isRequired,
    }),
  }),
}

export default Upsell
